var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssessmentLight = function SvgAssessmentLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 74,
    fill: "none",
    viewBox: "0 0 67 74"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 55.188,
    height: 65.188,
    x: 11.406,
    y: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#assessment-light_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#assessment-light_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__c)",
    d: "M22 20.745c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496c1.711-.872 3.952-.872 8.432-.872h8.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C56 14.025 56 16.265 56 20.745v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496c-1.711.872-3.952.872-8.432.872h-8.4c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C22 45.866 22 43.626 22 39.145z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M34.8 8.445h8.4c2.249 0 3.905 0 5.214.108 1.303.106 2.218.316 2.991.71a7.5 7.5 0 0 1 3.278 3.277c.394.773.603 1.688.71 2.991.106 1.31.107 2.966.107 5.214v18.4c0 2.249 0 3.905-.107 5.214-.107 1.303-.316 2.218-.71 2.992a7.5 7.5 0 0 1-3.278 3.277c-.773.394-1.688.603-2.99.71-1.31.107-2.966.107-5.215.107h-8.4c-2.249 0-3.905 0-5.214-.107-1.303-.107-2.218-.316-2.991-.71a7.5 7.5 0 0 1-3.278-3.277c-.394-.774-.603-1.689-.71-2.992-.107-1.309-.107-2.965-.107-5.214v-18.4c0-2.248 0-3.905.107-5.214.107-1.303.316-2.218.71-2.991a7.5 7.5 0 0 1 3.278-3.277c.773-.394 1.688-.604 2.99-.71 1.31-.107 2.966-.108 5.215-.108Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 55.188,
    height: 65.188,
    x: 3.406,
    y: 8
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#assessment-light_svg__d)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#assessment-light_svg__e)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__f)",
    fillOpacity: 0.5,
    d: "M14 28.745c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496c1.711-.872 3.952-.872 8.432-.872h8.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C48 22.025 48 24.265 48 28.745v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496c-1.711.872-3.952.872-8.432.872h-8.4c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C14 53.866 14 51.626 14 47.145z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__g)",
    fillOpacity: 0.25,
    d: "M14 28.745c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496c1.711-.872 3.952-.872 8.432-.872h8.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C48 22.025 48 24.265 48 28.745v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496c-1.711.872-3.952.872-8.432.872h-8.4c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C14 53.866 14 51.626 14 47.145z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M26.8 16.445h8.4c2.249 0 3.905 0 5.214.108 1.303.106 2.218.316 2.991.71a7.5 7.5 0 0 1 3.278 3.277c.394.773.603 1.688.71 2.991.106 1.31.107 2.966.107 5.214v18.4c0 2.249 0 3.905-.107 5.214-.107 1.303-.316 2.218-.71 2.992a7.5 7.5 0 0 1-3.278 3.277c-.773.394-1.688.603-2.99.71-1.31.107-2.966.107-5.215.107h-8.4c-2.249 0-3.905 0-5.214-.107-1.303-.107-2.218-.316-2.991-.71a7.5 7.5 0 0 1-3.278-3.277c-.394-.774-.603-1.689-.71-2.992-.106-1.309-.107-2.965-.107-5.214v-18.4c0-2.248 0-3.905.107-5.214.107-1.303.316-2.218.71-2.991a7.5 7.5 0 0 1 3.278-3.277c.773-.394 1.688-.604 2.99-.71 1.31-.107 2.966-.108 5.215-.108Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 47.188,
    height: 25.188,
    x: 7.406,
    y: 16
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#assessment-light_svg__h)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#assessment-light_svg__i)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__j)",
    fillOpacity: 0.2,
    d: "M18 25.945a2 2 0 0 1 2-2h22a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__k)",
    d: "M18 25.945a2 2 0 0 1 2-2h22a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M20 24.445h22a1.5 1.5 0 0 1 0 3H20a1.5 1.5 0 0 1 0-3Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 43.188,
    height: 25.188,
    x: 7.406,
    y: 24
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#assessment-light_svg__l)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#assessment-light_svg__m)",
    shapeRendering: "crispEdges"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__n)",
    fillOpacity: 0.2,
    d: "M18 33.945a2 2 0 0 1 2-2h18a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__o)",
    d: "M18 33.945a2 2 0 0 1 2-2h18a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2",
    style: {
      mixBlendMode: "screen"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M20 32.445h18a1.5 1.5 0 0 1 0 3H20a1.5 1.5 0 0 1 0-3Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 47.188,
    height: 25.188,
    x: 7.406,
    y: 32
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#assessment-light_svg__p)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#assessment-light_svg__q)",
    shapeRendering: "crispEdges"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__r)",
    fillOpacity: 0.2,
    d: "M18 41.945a2 2 0 0 1 2-2h22a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__s)",
    d: "M18 41.945a2 2 0 0 1 2-2h22a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2",
    style: {
      mixBlendMode: "screen"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M20 40.445h22a1.5 1.5 0 0 1 0 3H20a1.5 1.5 0 0 1 0-3Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 43.188,
    height: 25.188,
    x: 7.406,
    y: 40
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#assessment-light_svg__t)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#assessment-light_svg__u)",
    shapeRendering: "crispEdges"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__v)",
    fillOpacity: 0.2,
    d: "M18 49.945a2 2 0 0 1 2-2h18a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#assessment-light_svg__w)",
    d: "M18 49.945a2 2 0 0 1 2-2h18a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2",
    style: {
      mixBlendMode: "screen"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M20 48.445h18a1.5 1.5 0 0 1 0 3H20a1.5 1.5 0 0 1 0-3Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#assessment-light_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8 23.945-3.818 4L2 25.723",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#assessment-light_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8 39.945-3.818 4L2 41.723",
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#assessment-light_svg__z)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8 31.945-3.818 4L2 33.723",
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#assessment-light_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8 47.945-3.818 4L2 49.723",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__b",
    width: 55.188,
    height: 65.188,
    x: 11.406,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__e",
    width: 55.188,
    height: 65.188,
    x: 3.406,
    y: 8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__i",
    width: 47.188,
    height: 25.188,
    x: 7.406,
    y: 16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__m",
    width: 43.188,
    height: 25.188,
    x: 7.406,
    y: 24,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__q",
    width: 47.188,
    height: 25.188,
    x: 7.406,
    y: 32,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__u",
    width: 43.188,
    height: 25.188,
    x: 7.406,
    y: 40,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__x",
    width: 10,
    height: 8,
    x: 0,
    y: 22.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26706",
    result: "effect2_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__y",
    width: 10,
    height: 8,
    x: 0,
    y: 38.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26706",
    result: "effect2_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__z",
    width: 10,
    height: 8,
    x: 0,
    y: 30.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26706",
    result: "effect2_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "assessment-light_svg__A",
    width: 10,
    height: 8,
    x: 0,
    y: 46.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2555_26706",
    result: "effect2_dropShadow_2555_26706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2555_26706",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment-light_svg__c",
    x1: 40.063,
    x2: 40.063,
    y1: 8.592,
    y2: 81.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment-light_svg__f",
    x1: 31,
    x2: 31,
    y1: 35.47,
    y2: 59.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment-light_svg__j",
    x1: 31,
    x2: 31,
    y1: 25.72,
    y2: 27.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment-light_svg__n",
    x1: 29,
    x2: 29,
    y1: 33.72,
    y2: 35.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment-light_svg__r",
    x1: 31,
    x2: 31,
    y1: 41.72,
    y2: 43.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "assessment-light_svg__v",
    x1: 29,
    x2: 29,
    y1: 49.72,
    y2: 51.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment-light_svg__a",
    transform: "translate(-11.406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 20.745c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496c1.711-.872 3.952-.872 8.432-.872h8.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C56 14.025 56 16.265 56 20.745v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496c-1.711.872-3.952.872-8.432.872h-8.4c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C22 45.866 22 43.626 22 39.145z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment-light_svg__d",
    transform: "translate(-3.406 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28.745c0-4.48 0-6.72.872-8.432a8 8 0 0 1 3.496-3.496c1.711-.872 3.952-.872 8.432-.872h8.4c4.48 0 6.72 0 8.432.872a8 8 0 0 1 3.496 3.496C48 22.025 48 24.265 48 28.745v18.4c0 4.48 0 6.72-.872 8.432a8 8 0 0 1-3.496 3.496c-1.711.872-3.952.872-8.432.872h-8.4c-4.48 0-6.72 0-8.432-.872a8 8 0 0 1-3.496-3.496C14 53.866 14 51.626 14 47.145z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment-light_svg__h",
    transform: "translate(-7.406 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 25.945a2 2 0 0 1 2-2h22a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment-light_svg__l",
    transform: "translate(-7.406 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 33.945a2 2 0 0 1 2-2h18a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment-light_svg__p",
    transform: "translate(-7.406 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 41.945a2 2 0 0 1 2-2h22a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "assessment-light_svg__t",
    transform: "translate(-7.406 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 49.945a2 2 0 0 1 2-2h18a2 2 0 1 1 0 4H20a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment-light_svg__g",
    width: 1.882,
    height: 1.455,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment-light_svg__B",
    transform: "scale(.00184 .00142)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment-light_svg__k",
    width: 2.462,
    height: 16,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment-light_svg__B",
    transform: "scale(.0024 .01563)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment-light_svg__o",
    width: 2.909,
    height: 16,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment-light_svg__B",
    transform: "scale(.00284 .01563)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment-light_svg__s",
    width: 2.462,
    height: 16,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment-light_svg__B",
    transform: "scale(.0024 .01563)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "assessment-light_svg__w",
    width: 2.909,
    height: 16,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#assessment-light_svg__B",
    transform: "scale(.00284 .01563)"
  })))));
};
export default SvgAssessmentLight;